import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Modal,
  Select,
  Alert as AlertControl,
} from "react-bootstrap";
// Import Datepicker
import { DatePickerInput } from "rc-datepicker";
import { components } from "react-select";
import ServiceProgram from "./ServicePrograme/ServicePrograme";
// Import the default style
import "rc-datepicker/lib/style.css";
//popup message
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import moment from "moment";
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);

function ModalProgram(props) {
  //get data from program
  const { showProg, toggleProg, idProg, infos } = props;

  useEffect(() => {
    dataProgram();
  }, [idProg]);

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  //const popup message
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [sevirity, setSevirity] = useState("");
  const handleClose = () => {
    setOpen(false);
    window.location.reload();
  };

  // program variables
  const [typePlan, setType] = useState(""); //type vide ??
  const [capacity, setCapacite] = useState(null);
  const [designation, setDesignation] = useState(null);
  const [datePlaning, setSelectedDate] = useState(null);

  const [timeSL1, setTimeSL1] = useState(null);
  const [timeSL2, setTimeSL2] = useState(null);
  const [timeSL3, setTimeSL3] = useState(null);
  const [timeSL4, setTimeSL4] = useState(null);
  const [timeSL5, setTimeSL5] = useState(null);
  const [timeSL6, setTimeSL6] = useState(null);
  const [timeSL7, setTimeSL7] = useState(null);
  const [timeSL8, setTimeSL8] = useState(null);
  const [timeSL9, setTimeSL9] = useState(null);
  const [timeSL10, setTimeSL10] = useState(null);
  const [timeSL11, setTimeSL11] = useState(null);
  const [timeSL12, setTimeSL12] = useState(null);
  const [timeSL13, setTimeSL13] = useState(null);
  const [timeSL14, setTimeSL14] = useState(null);
  const [timeSL15, setTimeSL15] = useState(null);
  const [timeSL16, setTimeSL16] = useState(null);
  const [timeSL17, setTimeSL17] = useState(null);
  const [timeSL18, setTimeSL18] = useState(null);
  const [timeSL19, setTimeSL19] = useState(null);
  const [timeSL20, setTimeSL20] = useState(null);
  const [timeSL21, setTimeSL21] = useState(null);
  const [timeSL22, setTimeSL22] = useState(null);
  const [timeSL23, setTimeSL23] = useState(null);
  const [timeSL24, setTimeSL24] = useState(null);
  const [timeSL25, setTimeSL25] = useState(null);
  const [timeSL26, setTimeSL26] = useState(null);
  const [timeSL27, setTimeSL27] = useState(null);
  const [timeSL28, setTimeSL28] = useState(null);
  const [timeSL29, setTimeSL29] = useState(null);
  const [timeSL30, setTimeSL30] = useState(null);
  const [timeSL31, setTimeSL31] = useState(null);
  const [timeSL32, setTimeSL32] = useState(null);
  const [timeSL33, setTimeSL33] = useState(null);
  const [timeSL34, setTimeSL34] = useState(null);
  const [timeSL35, setTimeSL35] = useState(null);
  const [timeSL36, setTimeSL36] = useState(null);
  const [timeSL37, setTimeSL37] = useState(null);
  const [timeSL38, setTimeSL38] = useState(null);
  const [timeSL39, setTimeSL39] = useState(null);
  const [timeSL40, setTimeSL40] = useState(null);
  const [timeSL41, setTimeSL41] = useState(null);
  const [timeSL42, setTimeSL42] = useState(null);
  const [timeSL43, setTimeSL43] = useState(null);
  const [timeSL44, setTimeSL44] = useState(null);
  const [timeSL45, setTimeSL45] = useState(null);
  const [timeSL46, setTimeSL46] = useState(null);
  const [timeSL47, setTimeSL47] = useState(null);
  const [timeSL48, setTimeSL48] = useState(null);

  const row = infos.filter((x) => x.id == idProg);
  const dataProgram = () => {
    row.map((program) => {
      setDesignation(program.designation);
      setCapacite(program.capacity);
      setSelectedDate(program.datePlaning);
      setTimeSL1(program.timeSL1);
      setTimeSL2(program.timeSL2);
      setTimeSL3(program.timeSL3);
      setTimeSL4(program.timeSL4);
      setTimeSL5(program.timeSL5);
      setTimeSL6(program.timeSL6);
      setTimeSL7(program.timeSL7);
      setTimeSL8(program.timeSL8);
      setTimeSL9(program.timeSL9);
      setTimeSL10(program.timeSL10);
      setTimeSL11(program.timeSL11);
      setTimeSL12(program.timeSL12);
      setTimeSL13(program.timeSL13);
      setTimeSL14(program.timeSL14);
      setTimeSL15(program.timeSL15);
      setTimeSL16(program.timeSL16);
      setTimeSL17(program.timeSL17);
      setTimeSL18(program.timeSL18);
      setTimeSL19(program.timeSL19);
      setTimeSL20(program.timeSL20);
      setTimeSL21(program.timeSL21);
      setTimeSL22(program.timeSL22);
      setTimeSL23(program.timeSL23);
      setTimeSL24(program.timeSL24);
      setTimeSL25(program.timeSL25);
      setTimeSL26(program.timeSL26);
      setTimeSL27(program.timeSL27);
      setTimeSL28(program.timeSL28);
      setTimeSL29(program.timeSL29);
      setTimeSL30(program.timeSL30);
      setTimeSL31(program.timeSL31);
      setTimeSL32(program.timeSL32);
      setTimeSL33(program.timeSL33);
      setTimeSL34(program.timeSL34);
      setTimeSL35(program.timeSL35);
      setTimeSL36(program.timeSL36);
      setTimeSL37(program.timeSL37);
      setTimeSL38(program.timeSL38);
      setTimeSL39(program.timeSL39);
      setTimeSL40(program.timeSL40);
      setTimeSL41(program.timeSL41);
      setTimeSL42(program.timeSL42);
      setTimeSL43(program.timeSL43);
      setTimeSL44(program.timeSL44);
      setTimeSL45(program.timeSL45);
      setTimeSL46(program.timeSL46);
      setTimeSL47(program.timeSL47);
      setTimeSL48(program.timeSL48);
      setType(program.typePlan);
    });
  };
  const clearProgram = () => {
    // setDesignation(null);
    // setCapacite(null);
    // setSelectedDate(null);
    // setTimeSL1(null);
    // setTimeSL2(null);
    // setTimeSL3(null);
    // setTimeSL4(null);
    // setTimeSL5(null);
    // setTimeSL6(null);
    // setTimeSL7(null);
    // setTimeSL8(null);
    // setTimeSL9(null);
    // setTimeSL10(null);
    // setTimeSL11(null);
    // setTimeSL12(null);
    // setTimeSL13(null);
    // setTimeSL14(null);
    // setTimeSL15(null);
    // setTimeSL16(null);
    // setTimeSL17(null);
    // setTimeSL18(null);
    // setTimeSL19(null);
    // setTimeSL20(null);
    // setTimeSL21(null);
    // setTimeSL22(null);
    // setTimeSL23(null);
    // setTimeSL24(null);
    // setTimeSL25(null);
    // setTimeSL26(null);
    // setTimeSL27(null);
    // setTimeSL28(null);
    // setTimeSL29(null);
    // setTimeSL30(null);
    // setTimeSL31(null);
    // setTimeSL32(null);
    // setTimeSL33(null);
    // setTimeSL34(null);
    // setTimeSL35(null);
    // setTimeSL36(null);
    // setTimeSL37(null);
    // setTimeSL38(null);
    // setTimeSL39(null);
    // setTimeSL40(null);
    // setTimeSL41(null);
    // setTimeSL42(null);
    // setTimeSL43(null);
    // setTimeSL44(null);
    // setTimeSL45(null);
    // setTimeSL46(null);
    // setTimeSL47(null);
    // setTimeSL48(null);
    // setType(null);
    toggleProg();
  };

  // update planning
  const updatePlanning = () => {
    ServiceProgram.updatePlan(
      idProg,
      designation,
      datePlaning,
      capacity,
      timeSL1,
      timeSL2,
      timeSL3,
      timeSL4,
      timeSL5,
      timeSL6,
      timeSL7,
      timeSL8,
      timeSL9,
      timeSL10,
      timeSL11,
      timeSL12,
      timeSL13,
      timeSL14,
      timeSL15,
      timeSL16,
      timeSL17,
      timeSL18,
      timeSL19,
      timeSL20,
      timeSL21,
      timeSL22,
      timeSL23,
      timeSL24,
      timeSL25,
      timeSL26,
      timeSL27,
      timeSL28,
      timeSL29,
      timeSL30,
      timeSL31,
      timeSL32,
      timeSL33,
      timeSL34,
      timeSL35,
      timeSL36,
      timeSL37,
      timeSL38,
      timeSL39,
      timeSL40,
      timeSL41,
      timeSL42,
      timeSL43,
      timeSL44,
      timeSL45,
      timeSL46,
      timeSL47,
      timeSL48,
      typePlan
    ).then(
      (res) => {
        if (res.data.message.toString() === "La modification est bien faite!") {
          setMessage("La modification est bien faite!");
          setSevirity("success");
          setOpen(true);
          window.location.reload();
        } else {
          setMessage("Une erreur s'est produite lors la modification!");
          setSevirity("error");
          setOpen(true);
        }
        window.location.replace("/programe");
        clearProgram();
      },
      (error) => {
        error && setMessage("Une erreur !");
        setSevirity("error");
        setOpen(true);
      }
    );
  };
  //console.log("this is type plan: ", typePlan);
  // const handleChange = (e) => {
  //   e.target.value;
  //   setType(typePlan);
  // };

  const [contorl, setControl] = useState(false);
  console.log("this is infos", infos);
  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={sevirity}>
          {message}
        </Alert>
      </Snackbar>
      <Modal show={showProg} onHide={toggleProg} size="xl">
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={() => clearProgram()}
          />
          <div className="update">
            <h2>Modifier calendrier</h2>
            <hr />
            <>
              <Row>
                <Col lg={5}>
                  <Form.Control
                    style={{ marginTop: "40px" }}
                    type="text"
                    required
                    placeholder="Désignation"
                    value={designation}
                    onChange={(e) => {
                      setDesignation(e.target.value);
                      setControl(false);
                    }}
                  />

                  <DatePickerInput
                    minDate={new Date()}
                    required
                    onChange={(date) => setSelectedDate(date.toISOString())}
                    value={datePlaning}
                    className="my-custom-datepicker-component mb-4"
                  />
                  {infos.user && !infos.user.speciality && (
                    <Form.Group controlId="calendar.SelectCustom">
                      <Form.Control
                        as="select"
                        custom
                        required
                        value={typePlan}
                        onChange={(e) => {
                          setType(e.target.value);
                        }}
                      >
                        <option>No Covid</option>
                        <option>Covid</option>
                      </Form.Control>
                    </Form.Group>
                  )}

                  {/* <Select
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      padding: 5,
                      borderRadius: 5,
                      background: "#0097e6",
                      color: "white",
                      display: "flex",
                    }),
                  }}
                  components={{ SingleValue }}
                  isSearchable
                  isClearable
                  name="label"
                  options={data}
                  onChange={(typePlan) => {
                    typePlan && setType(typePlan.label);
                  }}
                  defaultValue={typePlan}
                  className="mb-4 cal"
                /> */}

                  <Form.Control
                    type="text"
                    placeholder="Capacité par tranche d'horaire"
                    className="mb-4"
                    required
                    value={capacity}
                    onChange={(e) => {
                      setCapacite(e.target.value);
                      setControl(false);
                    }}
                  />

                  {contorl && (
                    <AlertControl variant="warning">
                      Tous les champs sont obligatoires
                    </AlertControl>
                  )}
                </Col>

                <Col lg={7} sm={12}>
                  <h5>Sélectionnez les heures souhaitées :</h5>
                  <div className="time">
                    <h4>Matin :</h4>
                    <Row>
                      <span
                        style={{
                          backgroundColor: timeSL1 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL1) {
                            setTimeSL1(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL1(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        06:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL2 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL2) {
                            setTimeSL2(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL2(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        06:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL3 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL3) {
                            setTimeSL3(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL3(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        07:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL4 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL4) {
                            setTimeSL4(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL4(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        07:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL5 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL5) {
                            setTimeSL5(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL5(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        08:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL6 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL6) {
                            setTimeSL6(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL6(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        08:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL7 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL7) {
                            setTimeSL7(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL7(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        09:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL8 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL8) {
                            setTimeSL8(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL8(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        09:30
                      </span>

                      <span
                        style={{
                          backgroundColor: timeSL9 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL9) {
                            setTimeSL9(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL9(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        10:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL10 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL10) {
                            setTimeSL10(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL10(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        10:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL11 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL11) {
                            setTimeSL11(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL11(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        11:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL12 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL12) {
                            setTimeSL12(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL12(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        11:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL13 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL13) {
                            setTimeSL13(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL13(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        12:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL14 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL14) {
                            setTimeSL14(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL14(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        12:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL15 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL15) {
                            setTimeSL15(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL15(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        13:00
                      </span>
                    </Row>
                    <hr />
                    <h4>Aprés-Midi :</h4>
                    <Row>
                      <span
                        style={{
                          backgroundColor: timeSL16 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL16) {
                            setTimeSL16(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL16(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        13:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL17 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL17) {
                            setTimeSL17(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL17(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        14:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL18 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL18) {
                            setTimeSL18(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL18(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        14:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL19 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL19) {
                            setTimeSL19(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL19(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        15:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL20 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL20) {
                            setTimeSL20(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL20(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        15:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL21 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL21) {
                            setTimeSL21(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL21(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        16:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL22 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL22) {
                            setTimeSL22(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL22(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        16:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL23 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL23) {
                            setTimeSL23(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL23(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        17:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL24 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL24) {
                            setTimeSL24(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL24(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        17:30
                      </span>

                      <span
                        style={{
                          backgroundColor: timeSL25 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL25) {
                            setTimeSL25(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL25(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        18:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL26 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL26) {
                            setTimeSL26(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL26(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        18:30
                      </span>
                    </Row>
                    <hr />
                    <h4>Soir :</h4>
                    <Row>
                      <span
                        style={{
                          backgroundColor: timeSL27 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL27) {
                            setTimeSL27(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL27(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        19:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL28 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL28) {
                            setTimeSL28(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL28(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        19:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL29 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL29) {
                            setTimeSL29(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL29(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        20:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL30 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL30) {
                            setTimeSL30(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL30(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        20:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL31 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL31) {
                            setTimeSL31(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL31(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        21:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL32 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL32) {
                            setTimeSL32(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL32(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        21:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL33 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL33) {
                            setTimeSL33(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL33(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        22:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL34 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL34) {
                            setTimeSL34(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL34(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        22:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL35 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL35) {
                            setTimeSL35(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL35(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        23:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL36 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL36) {
                            setTimeSL36(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL36(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        23:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL37 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL37) {
                            setTimeSL37(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL37(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        00:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL38 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL38) {
                            setTimeSL38(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL38(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        00:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL39 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL39) {
                            setTimeSL39(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL39(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        01:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL40 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL40) {
                            setTimeSL40(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL40(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        01:30
                      </span>

                      <span
                        style={{
                          backgroundColor: timeSL41 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL41) {
                            setTimeSL41(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL41(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        02:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL42 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL42) {
                            setTimeSL42(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL42(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        02:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL43 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL43) {
                            setTimeSL43(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL43(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        03:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL44 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL44) {
                            setTimeSL44(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL44(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        03:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL45 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL45) {
                            setTimeSL45(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL45(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        04:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL46 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL46) {
                            setTimeSL46(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL46(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        04:30
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL47 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL47) {
                            setTimeSL47(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL47(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        05:00
                      </span>
                      <span
                        style={{
                          backgroundColor: timeSL48 ? "#2ecc71" : "#0097e6",
                        }}
                        onClick={(e) => {
                          if (timeSL48) {
                            setTimeSL48(null);
                            e.target.style.backgroundColor = "#0097e6";
                          } else {
                            setTimeSL48(e.target.innerText);
                            e.target.style.backgroundColor = "#2ecc71";
                          }
                        }}
                      >
                        05:30
                      </span>
                    </Row>
                  </div>

                  <Row>
                    <button
                      className="btn2 home"
                      style={{ margin: "30px auto", width: "130px" }}
                      // type="submit"
                      onClick={() =>
                        designation && capacity
                          ? updatePlanning()
                          : setControl(true)
                      }
                    >
                      Modifier
                    </button>
                  </Row>
                </Col>
              </Row>
            </>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalProgram;
